import React, { useState,Fragment ,useEffect } from 'react'
import { Icon,Placeholder, Card } from 'semantic-ui-react'
import { useTheme, Button,Typography, useMediaQuery } from '@material-ui/core';
import CSS from './Explore.module.css';




function Explore(props) {

  const [loading, setLoading] = useState(false)

  const onload = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }

  useEffect(() => {
    onload()    
  }, [])
  

  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.up('sm'))
  
  var vendorArray = [...props.vendorLists].reverse()

    
   
  return (
    <div className={`container pt-5 pb-5 ${CSS.container}`}>
    
      <Fragment>
      <Typography variant="h3">
      {props.sName}
      </Typography>
    <Typography className="mt-3 mb-4" variant="subtitle1">
      {props.about}
      </Typography>
      <Button disabled={loading} variant="outlined" color="default" onClick={props.back} >Back</Button>
      </Fragment>
    
        
        { 
        
        (vendorArray===[]) ? 
          ""
        : 
        
        vendorArray.map((v,i)=>

        <Card key={i} fluid className="p-3">
        <Card.Content>
          <Card.Header>

            {(mobile) ? (
              <Typography variant="h3">
               
               { (loading) ? 
                  <Placeholder >
                      <Placeholder.Header>
                        <Placeholder.Line />
                      </Placeholder.Header>
                    </Placeholder> :  
                    <Typography variant="h4">
                      {v.cName}
                    </Typography> }  
                  </Typography>
                  )
                  :
                (
                  (loading) ? 
                  <Placeholder >
                      <Placeholder.Header>
                        <Placeholder.Line />
                      </Placeholder.Header>
                    </Placeholder> :  
                    <Typography variant="h5">
                      <strong>{v.cName}</strong>
                    </Typography> 
                )
                }

          </Card.Header>
          <Card.Meta className="mt-2">
            {
              mobile ? 
              <Typography variant="h5">
              { loading ?
                (
                <Placeholder >
                  <Placeholder.Header>
                    <Placeholder.Line length="short" />
                  </Placeholder.Header>
                </Placeholder>
                )
                :
                <Fragment>
                {v.fullName}
                </Fragment>
              }
            </Typography>
            :
            <Typography variant="h6">
              { loading ?
                (
                <Placeholder >
                  <Placeholder.Header>
                    <Placeholder.Line length="short" />
                  </Placeholder.Header>
                </Placeholder>
                )
                :
                <Fragment>
                {v.fullName}
                </Fragment>
              }
            </Typography>
            }

          </Card.Meta>

          <Card.Description className="mt-2">
            <Typography variant="body1">
              {loading ? (<Placeholder >
                <Placeholder.Header>
                  <Placeholder.Line />
                  <Placeholder.Line />
                </Placeholder.Header>
              </Placeholder>) : 
                <div>
               <strong>Address :</strong>  {(v.address)}
                 <div className="mt-3">
               { (v.desc) ?  <Fragment> <strong>Description :</strong> {v.desc}</Fragment>  : "" }
                 </div>
               </div>
               }

            </Typography>
          </Card.Description>

        </Card.Content>
        {(mobile) ? (
          <Card.Content extra>
            {
              loading ? (<Placeholder >
                <Placeholder.Header>
                  <Placeholder.Line />
                </Placeholder.Header>
              </Placeholder>) :
                (<div>
                  <Icon style={{ marginRight: '0.5rem' }} size="large" name="mail" />
                    {v.email}
                  <Icon style={{ marginRight: '0.5rem', marginLeft: '1.5rem' }} size="large" name="phone" rotated="clockwise" />
                    {v.number}
                </div>)
            }

          </Card.Content>
          ) 
          : 
          (
            <Card.Content extra>
              {loading ? (<Placeholder >
                <Placeholder.Header>
                  <Placeholder.Line length="short" />
                  <Placeholder.Line length="short" />
                </Placeholder.Header>
              </Placeholder>)
                :
                <div>
                  <Icon style={{ marginRight: '1rem' }} size="large" name="mail" />
                    {v.email}
                  <br /><br />
                  <Icon style={{ marginRight: '1rem' }} size="large" name="phone" rotated="clockwise" />
                  {v.number}
                </div>
              }
            </Card.Content>
          )
        }
      </Card>    
        ) }       
    </div>
  )
}




export default Explore
